export default "__VITE_ASSET__DVxjapG___"